import React, { Component, Fragment } from 'react';
import Header from 'components/base/secure/header/header';
import Footer from 'components/base/secure/footer/footer';
import { Scrollbars } from 'react-custom-scrollbars';
import { inject } from 'mobx-react';

@inject('store')
class Base extends Component {
    constructor(props) {
        super(props);

        this.alignWrapperToContainer = this.alignWrapperToContainer.bind(this);

        this.headerRef = React.createRef();
        this.contentRef = React.createRef();
    }

    alignWrapperToContainer() {
        // TODO: Debounce

        const headerHeight = this.headerRef.current.offsetHeight;
        const windowHeight = window.innerHeight;
        const contentHeight = windowHeight - headerHeight;

        this.contentRef.current.setAttribute('style', `height: ${contentHeight}px`);
    }

    componentDidMount() {
        window.addEventListener('resize', this.alignWrapperToContainer);
        this.alignWrapperToContainer();

        // Request user data
        this.props.store.user.requestUserMe();
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.alignWrapperToContainer);
    }

    render() {
        return (
            <Fragment>
                <Header ref={this.headerRef} />
                {/*<div className="page-container">
                    <div className="page-content-wrapper">
                        <div className="content">
                            {this.props.children}
                        </div>
                        <Footer />
                    </div>
                </div>*/}
                <div ref={this.contentRef} style={{height: '100%'}}>
                    <Scrollbars style={{height: '100%'}}>
                        {this.props.children}
                        <Footer />
                    </Scrollbars>
                </div>
            </Fragment>
        );
    }
}

export default Base;


// WEBPACK FOOTER //
// ./src/components/base/secure/base.js